import axios from 'axios';
import Utils from '../Utils';

let defautRequestConfig = {
  baseURL: '/'
}

const defaultRestApi = axios.create(defautRequestConfig);
defaultRestApi.interceptors.request.use(function (config) {
    config.params = {
      locale: Utils.toLocaleCode( Utils.getCurrentLang()),
      '_': new Date().getTime(),
      withCredentials: true
      };
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

export default defaultRestApi;




// WEBPACK FOOTER //
// ./src/app/common/config/RestApiInstance.js